import React, { useEffect } from "react";

const WaConnect = () => {
  const params = new URLSearchParams(window.location.search);
  const target = params.get("target") || "";
  const decodedTarget = target ? decodeURIComponent(target) : "";
  const isAllowedTarget =
    decodedTarget.startsWith("https://account.unipile.com/") ||
    decodedTarget.startsWith("https://api3.unipile.com/");

  useEffect(() => {
    if (decodedTarget && isAllowedTarget) {
      // Use top-level navigation to avoid browser private-network protections
      // that block cross-origin iframe flows.
      window.location.replace(decodedTarget);
    }
  }, [decodedTarget, isAllowedTarget]);

  if (!decodedTarget || !isAllowedTarget) {
    return (
      <div
        className="waCallbackPage"
        style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}
      >
        <h2 style={{ color: "#c00", marginBottom: "12px" }}>Invalid WhatsApp connection URL</h2>
        <p style={{ color: "#555" }}>
          Please close this tab and retry from Connected Accounts.
        </p>
      </div>
    );
  }

  return (
    <div
      className="waCallbackPage"
      style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}
    >
      <h2 style={{ color: "#25D366", marginBottom: "12px" }}>
        Redirecting to WhatsApp connection...
      </h2>
      <p style={{ color: "#555", marginBottom: "12px" }}>
        If you are not redirected automatically, click below.
      </p>
      <button
        type="button"
        onClick={() => window.location.assign(decodedTarget)}
        style={{
          padding: "10px 24px",
          background: "#25D366",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "14px"
        }}
      >
        Continue
      </button>
    </div>
  );
};

export default WaConnect;
export { WaConnect };
